import { ColorChooser } from '../components/ColorChooser'
import { SelectCard } from '../components/SelectCard'
import { K3ComponentExtensions } from '@k3/core/src/lib/types/K3Extensions'

export const components: K3ComponentExtensions = {
  colorSelect: (Wrapped) => (props) => {
    if (props.variable.key === 'frontGlassColor') {
      const validValues = props.values.filter((v: any) => {
        const values = props.validOptions.filter((p: any) => v.id === p.valueId)
        return values.length > 0 ? values : null
      })
      if (props.validOptions.length > 1) {
        return (
          <ColorChooser
            {...props}
            Wrapped={Wrapped}
            validValues={validValues}
          />
        )
      }
    }
    return <Wrapped {...props} />
  },
  radio: (Wrapped) => (props) => {
    if (props.variable.key === 'eFormType') {
      return <SelectCard {...props} />
    }
    return <Wrapped {...props} />
  },
}
